import React, { Component } from 'react'
import { connect } from "react-redux"
import { withTranslation } from 'react-i18next'

import { H2, Text } from '@amzn/stencil-react-components/text'
import { Col } from '@amzn/stencil-react-components/layout'

class HowTo extends Component {

  parseJsonToStencil = (item) => {
    if (item.header) {
      return (<H2>{item.header}</H2>);
    } else if (item.list) {
      return (
        <Text fontWeight="medium">
          <ol style={{listStyleType: "decimal", paddingLeft: "20px"}}>
            {item.list.map((i, index) =>
              <li key={"HowToList_" + index}>{i}</li>
            )}
          </ol>
        </Text>
      );
    } else {
      return (
        <Text color="neutral90" fontWeight="medium">{item.paragraphs}</Text>
      );
    }
  }

  render() {
    const { content, employee } = this.props;
    const contentJson = JSON.parse(content);

      if (!content) {
        return null;
      }

      return (
        <Col gridGap="S200">
          {contentJson.map((content) =>
            content.broker_choice_cd === employee.broker_choice_cd &&
            content.content.map((item) =>
              this.parseJsonToStencil(item)
            )
          )}
        </Col>
      );
  }
}

const mapState = state => ({
  employee: state.employee,
  content: state.static_content.how_to_content
});

export default connect(mapState)(withTranslation('translationsV2')(HowTo));
